import React from 'react'

function AllBrands() {
  return (
    <div className="brands">
      <img src="/images/brands/google.svg" title="Google" alt="Google" loading="lazy" />
      <img
        src="/images/brands/apple.svg"
        title="Apple"
        className="brand-square"
        alt="Apple"
        loading="lazy"
      />
      <img
        src="/images/brands/netflix.svg"
        title="Netflix"
        alt="Netflix"
        loading="lazy"
      />
      <img src="/images/brands/paypal.svg" title="PayPal" alt="PayPal" loading="lazy" />
      <img src="/images/brands/slack.svg" title="Slack" alt="Slack" loading="lazy" />
      <img src="/images/brands/adobe.svg" title="Adobe" alt="Adobe" loading="lazy" />
      <img
        src="/images/brands/walmart.svg"
        title="Walmart"
        alt="Walmart"
        loading="lazy"
      />
      <img src="/images/brands/github.svg" title="Github" alt="GitHub" loading="lazy" />
      <img
        src="/images/brands/microsoft.svg"
        title="Microsoft"
        alt="Microsoft"
        loading="lazy"
      />
      <img src="/images/brands/pixar.svg" title="Pixar" alt="Pixar" loading="lazy" />
      <img
        src="/images/brands/starbucks.svg"
        title="Starbucks"
        className="brand-square"
        alt="Starbucks"
        loading="lazy"
      />
      <img src="/images/brands/visa.svg" title="Visa" alt="Visa" loading="lazy" />
      <img src="/images/brands/ibm.svg" title="IBM" alt="IBM" loading="lazy" />
      <img src="/images/brands/yahoo.svg" title="Yahoo" alt="Yahoo" loading="lazy" />
      <img
        src="/images/brands/mozilla.svg"
        title="Mozilla"
        alt="Mozilla"
        loading="lazy"
      />
      <img
        src="/images/brands/atlassian.svg"
        title="Atlassian"
        alt="Atlassian"
        loading="lazy"
      />
      <img
        src="/images/brands/code-cademy.svg"
        title="Code Cademy"
        alt="Code Cademy"
        loading="lazy"
      />
      <img
        src="/images/brands/att.svg"
        className="brand-square"
        title="AT&T"
        alt="AT&T"
        loading="lazy"
      />
      <img
        src="/images/brands/surveymonkey.svg"
        title="Survey Monkey"
        alt="Survey Monkey"
        loading="lazy"
      />
      <img
        src="/images/brands/uber.svg"
        className="brand-square"
        title="Uber"
        alt="Uber"
        loading="lazy"
      />
      <img
        src="/images/brands/verizon.svg"
        title="Verizon"
        alt="Verizon"
        loading="lazy"
      />
      <img src="/images/brands/airbnb.svg" title="Airbnb" alt="Airbnb" loading="lazy" />
      <img src="/images/brands/indeed.svg" title="Indeed" alt="Indeed" loading="lazy" />
      <img
        src="/images/brands/lego.svg"
        className="brand-square"
        title="Lego"
        alt="Lego"
        loading="lazy"
      />
      <img
        src="/images/brands/the-washington-post.svg"
        title="The Washington Post"
        alt="The Washington Post"
        loading="lazy"
      />
      <img src="/images/brands/oracle.svg" title="Oracle" alt="Oracle" loading="lazy" />
      <img
        src="/images/brands/pandora.svg"
        title="Pandora"
        alt="Pandora"
        loading="lazy"
      />
      <img
        src="/images/brands/american-express.svg"
        title="American Express"
        className="brand-square"
        alt="American Express"
        loading="lazy"
      />
      <img
        src="/images/brands/pinterest.svg"
        title="Pinterest"
        alt="Pinterest"
        loading="lazy"
      />
      <img
        src="/images/brands/allstate.svg"
        title="Allstate"
        alt="Allstate"
        loading="lazy"
      />
      <img
        src="/images/brands/salesforce.svg"
        title="Salesforce"
        alt="Salesforce"
        className="brand-square"
        loading="lazy"
      />
      <img
        src="/images/brands/dockyard.svg"
        title="Dockyard"
        alt="Dockyard"
        loading="lazy"
      />
      <img src="/images/brands/houzz.svg" title="Houzz" alt="Houzz" loading="lazy" />
      <img
        src="/images/brands/wayfair.svg"
        title="Wayfair"
        alt="Wayfair"
        loading="lazy"
      />
      <img
        src="/images/brands/samsung.svg"
        title="Samsung"
        alt="Samsung"
        loading="lazy"
      />
      <img
        src="/images/brands/staples.svg"
        title="Staples"
        alt="Staples"
        loading="lazy"
      />
      <img
        src="/images/brands/eharmony.svg"
        title="eHarmony"
        alt="eHarmony"
        loading="lazy"
      />
      <img src="/images/brands/forbes.svg" title="Forbes" alt="Forbes" loading="lazy" />
      <img
        src="/images/brands/general-electric.svg"
        title="General Electric"
        className="brand-square"
        alt="General Electric"
        loading="lazy"
      />
      <img
        src="/images/brands/godaddy.svg"
        title="Go Daddy"
        alt="Go Daddy"
        loading="lazy"
      />
      <img src="/images/brands/zillow.svg" title="Zillo" alt="Zillow" loading="lazy" />

      <img
        src="/images/brands/grubhub.svg"
        title="Grubhub"
        alt="Grubhub"
        loading="lazy"
      />
      <img
        src="/images/brands/harvard.svg"
        title="Harvard University"
        alt="Harvard University"
        loading="lazy"
      />
      <img
        src="/images/brands/university-of-maryland.svg"
        title="University of Maryland"
        alt="University of Maryland"
        loading="lazy"
      />
      <img
        src="/images/brands/cisco.svg"
        title="Cisco"
        alt="Cisco"
        className="brand-square"
        loading="lazy"
      />
      <img src="/images/brands/citrix.svg" title="Citrix" alt="Citrix" loading="lazy" />
      <img src="/images/brands/adp.svg" title="ADP" alt="ADP" loading="lazy" />
      <img
        src="/images/brands/hilton.svg"
        title="Hilton"
        alt="Hilton"
        className="brand-square"
        loading="lazy"
      />
      <img
        src="/images/brands/hp.svg"
        className="brand-square"
        title="HP"
        alt="HP"
        loading="lazy"
      />
      <img
        src="/images/brands/hpe.svg"
        className="brand-square"
        title="HPE"
        alt="HPE"
        loading="lazy"
      />

      <img src="/images/brands/intuit.svg" title="Intuit" alt="Intuit" loading="lazy" />
      <img src="/images/brands/kpmg.svg" title="KPMG" alt="KPMG" loading="lazy" />
      <img
        src="/images/brands/mass-mutual.svg"
        title="Mass Mutual"
        alt="Mass Mutual"
        loading="lazy"
      />
      <img
        src="/images/brands/match-com.svg"
        title="Match.com"
        alt="Match.com"
        loading="lazy"
      />
      <img
        src="/images/brands/new-york-times.svg"
        title="New York Times"
        alt="New York Times"
        loading="lazy"
      />
      <img
        src="/images/brands/capital-one.svg"
        title="Capital One"
        className="brand-square"
        alt="Capital One"
        loading="lazy"
      />
      <img
        src="/images/brands/siemens.svg"
        title="Siemens"
        alt="Siemens"
        loading="lazy"
      />
      <img
        src="/images/brands/ask.svg"
        className="brand-square"
        title="Ask"
        alt="Ask"
        loading="lazy"
      />
      <img
        src="/images/brands/new-york-university.svg"
        title="New York University"
        alt="New York University"
        loading="lazy"
      />
      <img src="/images/brands/avvo.svg" title="Avvo" alt="Avvo" loading="lazy" />
      <img
        src="/images/brands/bazaar-voice.svg"
        title="Bazaar Voice"
        className="brand-square"
        alt="Bazaar Voice"
        loading="lazy"
      />
      <img
        src="/images/brands/shutterstock.svg"
        title="Shutterstock"
        alt="Shutterstock"
        loading="lazy"
      />
      <img
        src="/images/brands/coinbase.svg"
        title="Coinbase"
        alt="Coinbase"
        loading="lazy"
      />
      <img
        src="/images/brands/credit-karma.svg"
        title="Credit Karma"
        alt="Credit Karma"
        loading="lazy"
      />
      <img
        src="/images/brands/okcupid.svg"
        title="Ok Cupid"
        alt="Ok Cupid"
        loading="lazy"
      />
      <img
        src="/images/brands/conde-nast.svg"
        title="Condé Naste"
        alt="Condé Nast"
        loading="lazy"
      />
      <img src="/images/brands/redfin.svg" title="Redfin" alt="Redfin" loading="lazy" />
      <img
        src="/images/brands/sap-concur.svg"
        title="SAP Concur"
        alt="SAP Concur"
        loading="lazy"
      />
      <img
        src="/images/brands/express-scripts.svg"
        title="Express Scripts"
        alt="Express Scripts"
        loading="lazy"
      />
      <img src="/images/brands/tumblr.svg" title="Tumblr" alt="Tumblr" loading="lazy" />
      <img
        src="/images/brands/uc-davis.svg"
        title="UC Davis"
        alt="UC Davis"
        loading="lazy"
      />
      <img
        src="/images/brands/betterment.svg"
        title="Betterment"
        alt="Betterment"
        loading="lazy"
      />
      <img
        src="/images/brands/university-of-michigan.svg"
        title="University of Michigan"
        className="brand-square"
        alt="University of Michigan"
        loading="lazy"
      />
      <img
        src="/images/brands/kneat-solutions.svg"
        title="Kneat Solutions"
        alt="Kneat Solutions"
        loading="lazy"
      />
      <img
        src="/images/brands/college-board.svg"
        title="College Board"
        alt="College Board"
        loading="lazy"
      />
      <img
        src="/images/brands/bae-systems.svg"
        title="BAE Systems"
        alt="BAE Systems"
        loading="lazy"
      />
      <img
        src="/images/brands/minitab.svg"
        title="Minitab"
        alt="Minitab"
        loading="lazy"
      />
      <img
        src="/images/brands/ari-fleet.svg"
        title="ARI Fleet"
        alt="ARI Fleet"
        className="brand-square"
        loading="lazy"
      />
    </div>
  )
}

export default AllBrands
